<script setup lang="ts">
import BankingWrapper from '@/application/layouts/ContentWrapper/BankingWrapper.vue';

defineProps<{
  bankAccessId: string,
  depotId: string,
  investmentId: string
}>();
</script>

<template>
  <BankingWrapper v-slot="{ token, onEmitError }">
    <!-- eslint-disable vue/v-on-event-hyphenation -->
    <!-- eslint-disable vue/attribute-hyphenation -->
    <ba-depot-investment-detail
      :token="token"
      :bankAccessId="bankAccessId"
      :depotId="depotId"
      :investmentId="investmentId"
      @emitError="(e) => onEmitError(e, 'ba-depot-investment-detail')"
    />
  </BankingWrapper>
</template>
